<div class="filter-bar" *ngIf="filters.length">
    <div class="filter-bar__controls">
        <ng-container *ngFor="let filter of filters">
            <label class="filter-bar__field" [attr.for]="'filter-' + filter.key">
                <span class="filter-bar__label">{{ filter.label }}</span>

                <select
                        *ngIf="filter.controlType === 'select'"
                        [id]="'filter-' + filter.key"
                        class="filter-bar__control"
                        [ngModel]="selectValue(filter.key)"
                        (ngModelChange)="onSelectModelChange(filter.key, $event)"
                >
                    <option value="">All</option>
                    <option *ngFor="let option of filter.options" [value]="option.value">
                        {{ option.label }}
                    </option>
                </select>

                <input
                        *ngIf="filter.controlType === 'search' || filter.controlType === 'text'"
                        [id]="'filter-' + filter.key"
                        class="filter-bar__control"
                        type="text"
                        [placeholder]="filter.placeholder || filter.label"
                        [value]="values[filter.key] || ''"
                        (input)="onSearchInput(filter.key, $event)"
                />

                <div *ngIf="filter.controlType === 'multiselect'" class="filter-bar__multiselect">
                    <label *ngFor="let option of filter.options" class="filter-bar__checkbox">
                        <input
                                type="checkbox"
                                [checked]="isSelected(filter.key, option.value)"
                                (change)="onMultiselectToggle(filter.key, option.value, $any($event.target).checked)"
                        />
                        <span>{{ option.label }}</span>
                    </label>
                </div>

                <div *ngIf="filter.controlType === 'date_range'" class="filter-bar__date-range">
                    <input
                            type="date"
                            class="filter-bar__control"
                            [attr.aria-label]="filter.label + ' from'"
                            [value]="dateRangeValue(filter.key, 'from')"
                            (change)="onDateRangeChange(filter.key, 'from', $event)"
                    />
                    <span class="filter-bar__date-separator">to</span>
                    <input
                            type="date"
                            class="filter-bar__control"
                            [attr.aria-label]="filter.label + ' to'"
                            [value]="dateRangeValue(filter.key, 'to')"
                            (change)="onDateRangeChange(filter.key, 'to', $event)"
                    />
                </div>
            </label>
        </ng-container>
    </div>

    <div class="filter-bar__actions">
        <button type="button" class="filter-bar__btn filter-bar__btn--primary" (click)="applyFilters()">
            Apply
        </button>
        <button type="button" class="filter-bar__btn" (click)="resetFilters()">
            Reset
        </button>
    </div>
</div>
